import { Button } from "@exopengithub/exokit/v2";
import { showSuccessNotification } from "molecules/notifications/notificationEvents";
import { Input } from "molecules/input/Input";
import { useTranslation } from "react-i18next";
import { IconCopy } from "@tabler/icons-react";

import { ExopenLogo } from "src/features/sidebar/ExopenLogo";

export const AddExactOnlineIntegrationExternalRedirect = () => {
	const { t } = useTranslation();

	const url = window.location.href.replace("external", "redirect");

	return (
		<div className="md:py-44">
			<div className="mx-auto max-w-lg p-6 md:rounded-lg md:bg-white md:shadow">
				<div className="w-24 text-green-500">
					<ExopenLogo />
				</div>
				<div className="font-semibold text-xl pb-3 pt-6 text-center">
					{t("Add data source")}
				</div>

				<div className="px-10 pb-6 text-center">
					{t(
						"Copy the link below and send to your contact with an Exopen account",
					)}
				</div>
				<div className="flex gap-4">
					<Input
						aria-label={t("Redirect link")}
						containerProps={{ className: "grow" }}
						defaultValue={url}
						disabled
					/>

					<Button
						variant="secondaryGray"
						onClick={async () => {
							await navigator.clipboard.writeText(url);
							showSuccessNotification({
								message: t("The link was copied to clipboard"),
							});
						}}
						icon={<IconCopy />}
					>
						{t("Copy link")}
					</Button>
				</div>
			</div>
		</div>
	);
};
